import { required, unique, shape, items, concatFailure } from '@totalsoft/pure-validations';

export const competenceOrderValidator = shape({
  approvalTypeId: required,
  appStatusId: required,  
  docStructureKey: required,
  expression: required,
});

export const competenceOrderRuleValidator = concatFailure(
  unique(x => x.orderId || {}, 'CompetenceOrder.Rule.Validators.OrderIdUnique'),
  items(
    shape({
      orderId: required,
      approvalTypeLevelId: required,
      ruleStatusId: required,
      expression: required
    })
  )
);
